import { createSelector } from 'reselect';

import { type Upload } from '@air/redux-uploader';

import { type AirState } from '~/store/types';

const uploadIdSelector = (_state: AirState, uploadId: Upload['id']) => uploadId;

export const publicUploadMetadataSelector = ({ publicUploadMetadata }: AirState) => publicUploadMetadata;

export const metadataForPublicUploadSelector = createSelector(
  publicUploadMetadataSelector,
  uploadIdSelector,
  (metadata, uploadId) => metadata[uploadId],
);
